import { createRouter, createWebHistory } from "vue-router";
import SectionLayout from "@/layouts/SectionLayout.vue";

import { businessPlanChildren } from "./sections/businessPlan.routes";
import { ediPlanChildren } from "./sections/ediPlan.routes";
import { hswPlanChildren } from "./sections/hswPlan.routes";
import { susPlanChildren } from "./sections/susPlan.routes";
import { ccaapChildren } from "./sections/ccaap.routes";

import { i18nGuard } from "./guards/i18n.guard";
import { titleGuard } from "./guards/title.guard";
import { bodyClassGuard } from "./guards/bodyClass.guard";
import { transitionGuard } from "./guards/transition.guard";

const routes = [
  {
    path: "/:locale(en|cy)?/business-plan",
    component: SectionLayout,
    children: businessPlanChildren,
  },
  {
    path: "/edi-plan",
    component: SectionLayout,
    children: ediPlanChildren,
  },
  {
    path: "/hsw-plan",
    component: SectionLayout,
    children: hswPlanChildren,
  },
  {
    path: "/sus-plan",
    component: SectionLayout,
    children: susPlanChildren,
  },
  {
    path: "/ccaap",
    component: SectionLayout,
    children: ccaapChildren,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/en/business-plan",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active-nav-link",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return false;
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});

router.beforeEach(i18nGuard);
router.beforeEach(titleGuard);
router.beforeEach(bodyClassGuard);
router.beforeEach(transitionGuard);

export default router;
